<template>
  <div class="period-container">
    <TextField
      v-model="frequency.count"
      type="number"
      :min="1"
      name="Count"
      no-label
      class="number-input mr-3"
      :field-error="findByName(validationErrors, 'Count')"
    />
    <label class="form-group flex-1 frequency-selector">
      <Select
        v-model="frequency.period"
        :name="frequencyName"
        :allow-empty="false"
        :options="frequencyOptions"
        :field-error="findByName(validationErrors, frequencyName)"
        data-vv-as="Period"
        no-label
        class="period-select"
      />
    </label>
  </div>
</template>

<script>
import { findByName } from "@/lib/vuelidate_helpers";

import TextField from "@/components/TextField.vue";
import CONSTANTS from "@/Constants.js";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  components: {
    TextField
  },
  props: {
    frequency: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: Number,
      default: 0
    },
    fullList: {
      type: Boolean,
      boolean: false
    },
    name: {
      type: String,
      default: "period-selector"
    },
    validationErrors: {
      type: Object,
      default: null
    }
  },
  setup() {
    return {
      v$: useVuelidate(),
      findByName
    };
  },
  validations() {
    return {
      frequency: {
        count: { required, $autoDirty: true },
        period: { required, $autoDirty: true }
      }
    };
  },
  computed: {
    frequencyName() {
      return `${this.id}_frequency`;
    },
    frequencyOptions() {
      const periods = this.fullList
        ? CONSTANTS.TASK_PERIODS
        : CONSTANTS.MEMBERSHIP_PERIODS;
      return [...periods].map((opt) => {
        const period = { ...opt };
        if (this.frequency.count > 1) {
          period.label = `${period.label}s`;
        }
        return period;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.period-container {
  display: flex;
  justify-content: center;
}

.number-input {
  width: 60px;
  min-width: 60px;
}

.period-select {
  width: 90px;
}
</style>
